module.exports = __webpack_public_path__ + "static/wizard_sun_elf_female-583098e3e064a77fc6d5d0303a26005d.png";